// extracted by mini-css-extract-plugin
module.exports = {"price":"ua","inverted":"ub","separator":"uc","strikeout":"ud","discount":"ue","preliminaryValue":"uf","gray":"ug","locked":"uh","finalPrice":"ui"};